import { useState } from "react";
import { useFavoritesCRUD } from "../api/favoritesHooks";
import { Favorite } from "./Favorite";
import { AddFavorite } from "./forms/AddFavorite";
import { FormWrapper } from "./forms/FormWrapper";
import { Button } from "./generic/Button";
import { TileList } from "./generic/TileList";

export const FavoritesList = ({ onClose, listId, addProduct, products }) => {
  const {
    favorites,
    loading,
    error,
    addFavorite,
    updateFavorite,
    deleteFavorite,
    refetchFavorites,
  } = useFavoritesCRUD(listId);

  const [addModalOpen, setAddModalOpen] = useState(false);

  return (
    <FormWrapper>
      <div
        style={{
          display: "grid",
          gridTemplateRows: "1fr 40px",
        }}
      >
        <TileList>
          {favorites.map((favorite) => {
            const isOnList = products.some(
              (product) => product.name.trim() === favorite.name.trim(),
            );

            return (
              <Favorite
                favorite={favorite}
                key={favorite.id}
                isOnList={isOnList}
                onDelete={deleteFavorite}
                onClick={
                  isOnList
                    ? undefined
                    : () => addProduct({ name: favorite.name.trim() })
                }
                loading={loading}
              />
            );
          })}
        </TileList>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "50% 50%",
            marginTop: "2rem",
            position: "fixed",
            bottom: 0,
            right: 0,
            left: 0,
            minHeight: 0,
          }}
        >
          <Button onClick={() => setAddModalOpen(true)}>➕</Button>
          <Button onClick={onClose}>⊘</Button>
        </div>

        {addModalOpen ? (
          <AddFavorite
            onClose={() => setAddModalOpen(false)}
            addFavorite={addFavorite}
            favorites={favorites}
          />
        ) : null}
      </div>
    </FormWrapper>
  );
};
